import { useQuery } from "@tanstack/react-query";

import { GO_HIRE_QUERY_KEYS } from "../queryKeys";
import { getJobCandidates } from "../services/job.services";

import { GetJobCandidatesFilters } from "../services/job.services";

export const useGetJobCandidates = ({
  jobId,
  filters,
}: {
  jobId?: string | number;
  filters?: GetJobCandidatesFilters;
}) =>
  useQuery({
    queryKey: GO_HIRE_QUERY_KEYS.candidates(jobId!, filters),
    queryFn: () => getJobCandidates(jobId!, filters),
    enabled: !!jobId,
  });
